import React from "react";
import Button from "@mui/material/Button";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { jsPDF } from "jspdf";

import { Dialog, DialogActions, DialogContent } from "@mui/material";

import ProjectTimeline from "./dark_version/ProjectDetails/ProjectTimeline";

import ProjectTeam from "./dark_version/ProjectDetails/ProjectTeam";
import ProjectBasicInfoPDF, {
  TitleStyleTypography,
} from "./dark_version/ProjectDetails/pdf/ProjectBasicInfoPDF";
import FinancialSummary from "./dark_version/ProjectDetails/pdf/FinancialSummary";
import ProjectProgressBar from "./dark_version/ProjectDetails/pdf/ProjectProgressBar";
import { useSelector } from "react-redux";
import ProjectProgress from "./dark_version/ProjectDetails/pdf/ProjectProgress";
import PDFUtils from "../../utils/PDFUtils";

interface IProps {
  pid: string;
}
export const numberTdStyle: any = { textAlign: "center" };
const ProjectPDF = (props: IProps) => {
  const step1Ref = React.useRef<HTMLDivElement>(null);
  const step2Ref = React.useRef<HTMLDivElement>(null);
  const step3Ref = React.useRef<HTMLDivElement>(null);
  const step4Ref = React.useRef<HTMLDivElement>(null);
  const step5Ref = React.useRef<HTMLDivElement>(null);
  const step6Ref = React.useRef<HTMLDivElement>(null);
  const mainRef = React.useRef<HTMLDivElement>(null);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const addPageInPDF = async (pdf: jsPDF, page: HTMLElement, yOffset: number) => {
  //     const mx = 10;
  //     const my = 10;
  //
  //     const pageWidth = pdf.internal.pageSize.getWidth() - 2 * mx;
  //     const pageHeight = pdf.internal.pageSize.getHeight() - 2 * my;
  //
  //     // Capture the HTML content
  //     const canvas = await html2canvas(page, {scale: 2});
  //     const imgData = canvas.toDataURL('image/png');
  //     const imgWidth = pageWidth;
  //
  //
  //     let remainingHeight = (canvas.height * imgWidth) / canvas.width;
  //     let y = yOffset;
  //
  //     while (remainingHeight > 0) {
  //         const availableHeight = pageHeight - y;
  //         const heightToRender = Math.min(remainingHeight, availableHeight);
  //
  //         pdf.addImage(imgData, 'PNG', mx, y, imgWidth, heightToRender);
  //         remainingHeight -= heightToRender;
  //
  //         if (remainingHeight > 0) {
  //             pdf.addPage();
  //             y = my;
  //         } else {
  //             y += heightToRender;
  //         }
  //     }
  //
  //     return y;
  // };

  const createPDF = async () => {
    // const pdf = new jsPDF("p", "px", "a4");
    // let yOffset = 10; // Initial offset for the first page
    //
    // yOffset = await addPageInPDF(pdf, step1Ref?.current as HTMLElement, yOffset);
    // yOffset = await addPageInPDF(pdf, step2Ref?.current as HTMLElement, yOffset);
    // yOffset = await addPageInPDF(pdf, step3Ref?.current as HTMLElement, yOffset);
    // yOffset = await addPageInPDF(pdf, step4Ref?.current as HTMLElement, yOffset);
    // yOffset = await addPageInPDF(pdf, step5Ref?.current as HTMLElement, yOffset);
    // await addPageInPDF(pdf, step6Ref?.current as HTMLElement, yOffset);
    //
    // let title = document.getElementById("summary_project_title")?.innerHTML;
    // title = title ? title.replaceAll(" ", "_") + `_pid_${props.pid}` : `pid_${props.pid}`;
    // pdf.save(`${title}.pdf`);
    const pdfUtils = new PDFUtils();
    pdfUtils
      .generatePDF(mainRef.current as HTMLElement, 200, 50)
      .then((pdf: jsPDF) => {
        let title = document.getElementById("summary_project_title")?.innerHTML;
        title = title
          ? title.replaceAll(" ", "_") + `_pid_${props.pid}`
          : `pid_${props.pid}`;
        pdf.save(`${title}.pdf`);
      });
  };

  const financialProgress = useSelector(
    (state: any) => state.projectInfo.financialProgress,
  );
  const teams = useSelector((state: any) => state.projectInfo.teams);
  return (
    <React.Fragment>
      <Button
        onClick={handleClickOpen}
        sx={{ marginRight: "10px" }}
        variant="contained"
      >
        <PictureAsPdfOutlinedIcon /> PDF Preview
      </Button>
      <Dialog open={open} maxWidth={"lg"} fullWidth={true} fullScreen={true}>
        <DialogContent>
          <div ref={mainRef} style={{ display: "block", padding: 10 }}>
            <div ref={step1Ref} style={{ display: "block", padding: 10 }}>
              <ProjectBasicInfoPDF />
            </div>
            <div ref={step2Ref} style={{ display: "block", padding: 10 }}>
              <TitleStyleTypography>
                Financial Summary (US$ Million)
              </TitleStyleTypography>
              <FinancialSummary />
            </div>
            <div ref={step3Ref} style={{ display: "block", padding: 10 }}>
              <TitleStyleTypography>Project Timeline</TitleStyleTypography>
              <ProjectTimeline />
            </div>
            <div ref={step4Ref} style={{ display: "block", padding: 10 }}>
              <TitleStyleTypography>Financial Progress</TitleStyleTypography>
              <ProjectProgressBar progress={financialProgress} />
            </div>
            <div ref={step5Ref} style={{ display: "block", padding: 10 }}>
              <TitleStyleTypography>Project Progress</TitleStyleTypography>
              {/*<PhysicalStatus/>*/}
              <ProjectProgress />
            </div>
            <div ref={step6Ref} style={{ display: "block", padding: 10 }}>
              <TitleStyleTypography>Project Focal Person</TitleStyleTypography>
              <ProjectTeam teams={teams} />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          {/*<Button onClick={handleClose}>Disagree</Button>*/}
          <Button onClick={createPDF} autoFocus>
            Save as PDF
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ProjectPDF;
